import * as Forms from '../../components/forms';
import React      from 'react';
import Thanks     from './thank_you';


export function Form({ onSubmit, onLoginClick }) {
  return (
    <React.Fragment>
      <div className="block inset">
        <h3>Password Help</h3>
        <p>
          Having trouble signing in? Enter your account phone number and then click Continue. We&#x27;ll send you an SMS with a new link to sign in.
        </p>
      </div>
      <Forms.Form save={onSubmit}>
        <Fields/>
      </Forms.Form>
      <div className="block inset">
        <a onClick={onLoginClick}>Back to login</a>
      </div>
    </React.Fragment>
  );
}

function Fields(form) {
  return (
    <div className="list block inset">
      <ul>
        <Forms.Error  {...form}/>
        <Forms.Input  {...form} label="Phone" name="phone" type="tel" maxLength="14" autoFocus required/>
        <Forms.Button {...form} label="Continue"/>
      </ul>
    </div>
  );
}


export function ThankYou({ phone, onLoginClick }) {
  return (
    <Thanks onLoginClick={onLoginClick}>
      <p>
        You entered <b>{phone}</b>. If this is the correct
        phone number, we will send you an SMS with a link to sign in.
        <br/><br/>
        If you don&#x27;t receive an SMS, you may want to try the following:
      </p>
      <ul>
        <li>Check that you have provided the phone number that&#x27;s associated with your Broadly account.</li>
        <li>Wait a bit longer for the SMS to arrive.</li>
        <li>Contact Broadly&#x27;s Customer Success team for further assistance.</li>
      </ul>
    </Thanks>
  );
}
